exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-tooltip__popper{max-width:30% !important}::v-deep .el-table__body tr.hover-row>td{background-color:#eaecfc !important}", ""]);

// exports
